/*
 * SerranoMarkt — serrano-variant-modal.js
 * ============================================================================
 * Amac: Koleksiyon / anasayfa / liste URUN KARTLARINDAKI "Sepete Ekle"
 * davranisini guvenli hale getirmek.
 *
 *  - Secenek (Globo) gerektiren VEYA native cok-varyantli urun:
 *      kart "Sepete Ekle" -> URUN SAYFASINA yonlendirir. (Daily Nuuds
 *      "kendi paketini olustur" gibi cok-renk + her renkten adet secimi
 *      yalnizca urun sayfasinda, Globo'nun kendi sisteminde dogru yapilir.)
 *  - Seceneksiz basit urun: temanin dogal ekleme akisina DOKUNULMAZ.
 *
 * KESIN KURALLAR (onceki surumun yol actigi hatalara karsi):
 *  1) URUN SAYFASI (/products/...) ASLA intercept edilmez. (Onceki surum
 *     urun sayfasini da yakalayip Globo'nun cok-renkli paketini tek renge
 *     dusuruyordu -> siparisler tek renk gidiyordu. Bir daha olmayacak.)
 *  2) Secenek/varyant tespiti GERCEK veri kaynagindan yapilir:
 *     window.GPOConfigs.options[..].products.rule  +  native variant sayisi.
 *  3) Hicbir modal acilmaz, hicbir adet adimlayici eklenmez, sepete sessizce
 *     varsayilan varyant EKLENMEZ.
 *
 * NOT: "Translation missing: tr.*" hatasi bu dosyadan kaynaklanmaz; o,
 * locales/tr.json (tema ceviri dosyasi) kaynaklidir ve ayrica duzeltilir.
 * ============================================================================
 */
(function () {
  'use strict';

  var FORM_SELECTOR = 'form.quick-buy-product-form, form[action*="/cart/add"][data-product-handle]';

  // Urun sayfasinda isek HICBIR sey yapma (Globo orada calisiyor)
  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  function islandData(form) {
    var island = form.closest('data-island');
    if (island && window.Alpine) {
      try { return window.Alpine.$data(island) || null; } catch (e) { return null; }
    }
    return null;
  }

  // Shopify PRODUCT ID (variant id degil) — Globo eslesmesi icin
  function getProductId(form) {
    var d = islandData(form);
    if (d && d.product && d.product.id) return String(d.product.id);
    var island = form.closest('data-island');
    var xData = (island && island.getAttribute('x-data')) || '';
    var m = xData.match(/["']?id["']?\s*:\s*(\d+)/);
    return m ? m[1] : null;
  }

  // Bu urun Globo secenegi gerektiriyor mu?
  function needsGloboOptions(productId) {
    if (!productId) return false;
    var sets = (window.GPOConfigs && window.GPOConfigs.options) || {};
    for (var key in sets) {
      if (!Object.prototype.hasOwnProperty.call(sets, key)) continue;
      var rule = sets[key] && sets[key].products && sets[key].products.rule;
      if (!rule) continue;
      if (rule.type === 'all') return true;
      var ids = (rule.manual && rule.manual.ids) || [];
      for (var i = 0; i < ids.length; i++) {
        if (String(ids[i]) === String(productId)) return true;
      }
    }
    return false;
  }

  // Native (Shopify) cok varyantli mi?
  function nativeMultiVariant(form) {
    var d = islandData(form);
    var p = d && d.product;
    if (!p) return false;
    var variants = p.variants || [];
    return p.has_only_default_variant === false && variants.length > 1;
  }

  function productUrl(form) {
    var d = islandData(form);
    var p = d && d.product;
    if (p && p.url) return p.url;
    var handle = (form.dataset && form.dataset.productHandle) || (p && p.handle);
    var card = form.closest('li, .product-card, .product-tile, [class*="product"]') || form;
    var link = card.querySelector('a[href*="/products/"]');
    if (link) return link.getAttribute('href');
    return handle ? ('/products/' + handle) : null;
  }

  // Bu urun icin kart eklemesini durdurup urun sayfasina goturmeli miyiz?
  function shouldRedirect(form) {
    var pid = getProductId(form);
    return needsGloboOptions(pid) || nativeMultiVariant(form);
  }

  function redirectFromForm(form, e) {
    var url = productUrl(form);
    if (!url) return false;           // url yoksa dogal akisa dokunma
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url;
    return true;
  }

  function onSubmitCapture(e) {
    if (isProductPage()) return;
    var form = e.target && e.target.closest && e.target.closest(FORM_SELECTOR);
    if (!form) return;
    if (!shouldRedirect(form)) return;   // basit urun -> dogal ekleme
    redirectFromForm(form, e);
  }

  function onClickCapture(e) {
    if (isProductPage()) return;
    var btn = e.target && e.target.closest && e.target.closest(
      'button[type="submit"], button[name="commit"], .push-btn, .product-card__quick-add-button, .quick-add__submit'
    );
    if (!btn) return;
    var form = btn.closest(FORM_SELECTOR);
    if (!form) return;
    if (!shouldRedirect(form)) return;
    redirectFromForm(form, e);
  }

  document.addEventListener('submit', onSubmitCapture, true);
  document.addEventListener('click', onClickCapture, true);
})();